import WordsyContainer from 'components/Game/Wordsy/WordsyContainer'
import WordsyData from 'components/Game/Wordsy/WordsyData'
import WordsyPresentation from 'components/Game/Wordsy/WordsyPresentation'

export default {
  Container: WordsyContainer,
  Data: WordsyData,
  Presentation: WordsyPresentation,
}
